import React, { useState } from 'react';
// import { Box } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {
  Container,
  SectionTitle,
  WarningBox,
  WorkerDetailsBox,
  WorkerAvatar,
  WorkerInfoText,
  WorkerName,
  WorkerMetaText,
} from './styles';
import { MoreHoriz } from '@mui/icons-material';
import { IconButton, Chip, Box, Menu, Typography, MenuItem } from '@mui/material';

interface WorkerAssignedProps {
  assignedWorkerName?: string;
  positionRole: string;
  workerId?: number;
  avatarSrc?: string;
  status?: string;
  isLate?: boolean;
  onFlagWorker?: () => void;
  onReplaceWorker?: () => void;
  workerRemarks?: string;
}

const WorkerAssigned: React.FC<WorkerAssignedProps> = ({
  assignedWorkerName,
  positionRole,
  workerId,
  avatarSrc,
  status,
  isLate,
  onFlagWorker,
  onReplaceWorker,
  workerRemarks
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);

  const handleMenuButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuButtonClose = () => {
    setAnchorEl(null);
  };

  const handleFlagWorkerClick = () => {
    if (onFlagWorker) {
      onFlagWorker();
    }
    handleMenuButtonClose();
  };

  const handleReplaceWorkerClick = () => {
    if (onReplaceWorker) {
      onReplaceWorker();
    }
    handleMenuButtonClose();
  };

  const menuItems = [
    { key: 'flag_worker', label: 'Flag Worker', isDanger: true, onClick: handleFlagWorkerClick },
    ...(onReplaceWorker ? [{ key: 'replace_worker', label: 'Replace Worker', isDanger: false, onClick: handleReplaceWorkerClick }] : []),
  ];

  return (
    <Container>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
        <SectionTitle style={{ marginBottom: 0 }}>Worker Assigned</SectionTitle>
        {assignedWorkerName && onFlagWorker && (
          <>
            <IconButton size="small" onClick={handleMenuButtonClick}>
              <MoreHoriz />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleMenuButtonClose}
              PaperProps={{
                elevation: 3,
                sx: {
                  borderRadius: 2,
                  right: '42px !important',
                  left: 'auto !important',
                },
                style: {
                  maxHeight: 48 * 4.5,
                },
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              {menuItems.map((action) => (
                <MenuItem
                  key={action.key}
                  onClick={(e) => {
                    // alert('Menu Item Clicked');
                    console.log('Menu item clicked:', action.key);
                    action.onClick();
                  }}
                  sx={{
                    color: action.isDanger ? 'error.main' : 'inherit',
                  }}
                >
                  <Typography variant="body2" fontWeight={500}>
                    {action.label}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </>
        )}
      </div>

      {assignedWorkerName ? (
        <WorkerDetailsBox>
          <WorkerAvatar src={avatarSrc || "https://via.placeholder.com/150"} alt={assignedWorkerName} />
          <WorkerInfoText style={{ width: '100%' }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <WorkerName>{assignedWorkerName}</WorkerName>
              {status && (
                <Chip
                  label={status}
                  size="small"
                  sx={{
                    height: 24,
                    fontSize: '0.75rem',
                    backgroundColor: isLate ? '#FFEBEE' : '#E8F5E9',
                    color: isLate ? '#D32F2F' : '#2E7D32',
                    fontWeight: 600
                  }}
                />
              )}
            </Box>
            <WorkerMetaText>ID: {workerId || '-'}</WorkerMetaText>
            <WorkerMetaText>Role: {positionRole}</WorkerMetaText>
            {workerRemarks && (
              <WorkerMetaText style={{ marginTop: '8px', fontStyle: 'italic' }}>
                <span style={{ fontWeight: 600 }}>Remarks:</span> {workerRemarks}
              </WorkerMetaText>
            )}
          </WorkerInfoText>
        </WorkerDetailsBox>
      ) : (
        <WarningBox>
          <WarningAmberIcon fontSize="small" />
          {`${positionRole} (0/1) - Unassigned`}
        </WarningBox>
      )}
    </Container>
  );
};

export default WorkerAssigned;
